<template>
  <div class="tutorBox">
    <img
      @click='enterDetails()'
      class="courseTutor"
      :src="cover"
      alt=""
    >
    <div
      class="goCourse"
      @click='enterDetails()'
    >前往了解课程</div>
  </div>
</template>

<script>
import { reqTypeList } from '@/api/home';
import { reqCourseDetail } from '@/api/courseDetail';

export default {
  component: {
  },
  props: {

  },
  data() {
    return {
      productId: '', // 课程id
      cover: '', // 课程主图
    };
  },

  computed: {

  },
  mounted() {
  },
  created() {
    this.getTypeList();
  },
  methods: {
    // 基础字段配置
    async getTypeList() {
      const res = await reqTypeList('SENIOR_CONF');
      if (res?.code === 0) {
        this.productId = res?.data[0].value;
        this.getCourseCover(this.productId);
      }
    },
    // 查询课程主图
    async getCourseCover(courseId) {
      const res = await reqCourseDetail(courseId);
      if (res?.code === 0) {
        this.cover = res?.data.coverMobile;
      }
    },
    // 跳普通产品课程详情
    enterDetails() {
      // if(this.$root.whatEev=='miniprogram'){
      //   this.$toast('请前往app查看');
      //   return
      // }
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(this.productId), false);
        return;
      }
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: Number(this.productId),
        },
      });
    },
  },
};

</script>

<style lang="scss" scoped>
.tutorBox {
  margin-top: 22px;
  .courseTutor {
    width: 678px;
    height: 489px;
    border-radius: 14px;
  }
  .goCourse {
    width: 100%;
    height: 80px;
    margin-top: 72px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 45px;
  }
}
</style>
